import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import cx from "classnames";

function View(props, { locals }) {
  const { snapshot, momentTZ } = locals;
  const activeExercises = _.get(snapshot, "data.activeExercises", {});
  const activeDay = momentTZ(
    _.get(_.first(activeExercises), "date", momentTZ())
  );

  return (
    <div className="body metrics">
      <h1 className="alt">{activeDay.format("dddd. MMMM D, YYYY")}</h1>
      <br />
      <div className="Workout">
        <div className="head">EXERCISES</div>
        <div className="details">
          {_.map(activeExercises, (exercise, i) => {
            const primary = _.get(exercise, "primary");
            const defaultRepMax = locals.fromMetric(
              _.get(exercise, `repMaximums.${primary}`, 0)
            );
            const isAssistant = primary === "assistant";
            const equipped = !isAssistant && _.some(exercise.sets, "equipped");

            return (
              <div
                className={cx("Exercise", primary, { equipped })}
                key={exercise._id}
              >
                <div className="head">
                  {_.capitalize(primary)}{" "}
                  {exercise.secondary &&
                    `(${_.capitalize(exercise.secondary)})`}
                </div>

                <div className="details">
                  <div className="details-col-1">
                    {_.map(exercise.sets, (it) => {
                      const equippedRepMax = locals.fromMetric(
                        it.equippedRepMax
                      );
                      const repMax = equippedRepMax || defaultRepMax;
                      const load = locals.fromMetric(it.load);
                      const percentRM = _.round((load / repMax) * 100, 1);
                      const isEquipped = !isAssistant && it.equipped;
                      const hasLoad = Boolean(load);
                      return (
                        <div className="routine">
                          <div>
                            <b>Sets</b> {it.sets}
                          </div>
                          <div>
                            <b>Reps</b> {it.reps}
                          </div>
                          {hasLoad && (
                            <div>
                              <b>Load</b> {locals.withWeight(load)}
                            </div>
                          )}
                          {hasLoad && !isAssistant && (
                            <div>
                              <b>Intensity</b> {percentRM}%
                            </div>
                          )}
                          {it.rpe > 0 && (
                            <div>
                              <b>RPE</b> {it.rpe}
                            </div>
                          )}

                          {isEquipped && (
                            <div>
                              <b>Equipped</b> {it.equipment}
                            </div>
                          )}

                          {isEquipped && (
                            <div>
                              <b>Equipped RM</b>{" "}
                              {locals.withWeight(equippedRepMax)}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className="details-col-2">
                    {exercise.notes && (
                      <div className="notes">
                        <b>Notes</b> {exercise.notes}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

View.contextTypes = { locals: PropTypes.object };

export default View;
